import { Avatar, Box, Stack, Tooltip, Typography } from "@mui/material"
import { useSistemas, useSistemasPrincipal } from "src/pages/messages/api"
import { EntityWithIdAndDescriptionFields, EntityWithIdFields } from "src/types"

const CountryAvatar = ({ id, label }: { id: number, label: string }) => {

    const logoPorSistemaPrincipal: Record<number, string> = {
        1: '/images/flags/argentina-icon.png',
        2: '/images/flags/paraguay-icon.png',
        3: '/images/flags/uruguay-icon.png',
        4: '/images/flags/panama-icon.png',
        5: '/images/flags/usa-icon.png',
    }

    return (
        <Tooltip title={label}>
            <Avatar
                sx={{ height: '40px', width: '40px' }}
                src={logoPorSistemaPrincipal[id]}
            />
        </Tooltip>
    )
}

export const InfoNuevoMensajeDesktop = ({ codSistemaPrincipal, codSistema, codSistemaTipo }: { codSistemaPrincipal: number, codSistema: number, codSistemaTipo: number }) => {

    const { sistemasPrincipal } = useSistemasPrincipal()
    const { sistemas } = useSistemas(true)

    if (!sistemasPrincipal || !sistemas)
        return <div></div>

    const sistemaPrincipal = sistemasPrincipal.find(sistema => sistema[EntityWithIdFields.Id] === codSistemaPrincipal)
    const sistemaActual = sistemas.find(sistema => sistema[EntityWithIdFields.Id] === codSistemaTipo)

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}
        >
            <Stack
                direction='row'
                spacing={2}
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center'
                }}
            >
                <CountryAvatar
                    id={codSistemaPrincipal}
                    label={sistemaPrincipal?.descripcion || ''}
                />
                <Typography variant='h6'>
                    {sistemaActual?.[EntityWithIdAndDescriptionFields.Description]}
                </Typography>
            </Stack>
        </Box>
    )
}
